// Privacy Policy / Terms of Service reader screen.

import React, { useEffect, useMemo } from "react";
import "./App.css";
import AppFooter from "./Components/AppFooter";
import { getLegalDoc } from "./data/legalContent";

const Legal = ({
    docId = "privacy",
    onBack,
    onPrivacyPolicy,
    onTermsOfService,
}) => {
    const doc = useMemo(() => getLegalDoc(docId), [docId]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [docId]);

    if (!doc) {
        return (
            <div className="legalScreen">
                <div className="legalScreen__panel">
                    <h1 className="impactFont pageTitle">Legal</h1>
                    <p className="friendsBody">Document not found.</p>
                    <button
                        type="button"
                        className="homePrimaryButton"
                        onClick={onBack}
                    >
                        Back
                    </button>
                </div>
                <AppFooter
                    variant="overlay"
                    onPrivacyPolicy={onPrivacyPolicy}
                    onTermsOfService={onTermsOfService}
                />
            </div>
        );
    }

    return (
        <div className="legalScreen">
            <div className="legalScreen__panel">
                <div className="legalScreen__header">
                    <h1 className="impactFont pageTitle legalScreen__title">
                        {doc.title}
                    </h1>
                    <p className="legalScreen__updated">Updated {doc.updated}</p>
                </div>

                <div className="legalScreen__tabs" role="tablist" aria-label="Legal documents">
                    <button
                        type="button"
                        role="tab"
                        aria-selected={docId === "privacy"}
                        className={`friendsTab${
                            docId === "privacy" ? " friendsTab--active" : ""
                        }`}
                        onClick={onPrivacyPolicy}
                    >
                        Privacy
                    </button>
                    <button
                        type="button"
                        role="tab"
                        aria-selected={docId === "terms"}
                        className={`friendsTab${
                            docId === "terms" ? " friendsTab--active" : ""
                        }`}
                        onClick={onTermsOfService}
                    >
                        Terms
                    </button>
                </div>

                <div className="legalScreen__body">
                    {doc.sections.map((section) => (
                        <section
                            key={section.heading}
                            className="legalScreen__section"
                        >
                            <h2 className="legalScreen__heading">
                                {section.heading}
                            </h2>
                            {section.paragraphs.map((paragraph) => (
                                <p
                                    key={paragraph.slice(0, 48)}
                                    className="legalScreen__paragraph"
                                >
                                    {paragraph}
                                </p>
                            ))}
                        </section>
                    ))}
                </div>

                <div className="legalScreen__actions">
                    <button
                        type="button"
                        className="homePrimaryButton"
                        onClick={onBack}
                    >
                        Back
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Legal;
